import { PopupIds } from '../../../../../components/popupPanel/popupConstants';

export const NOTIFICATION_SET_SELECTED = 'NOTIFICATION_SET_SELECTED';

export const NOTIFICATIONS_POPUP_ID = PopupIds.NOTIFICATIONS;
